import type { ConfirmedEvent, DayKey, Registration, RegistrationClass } from '../types'
import { formatDate } from '../i18n/dates'

export type InvitationAttachmentItem = Pick<ConfirmedEvent | Registration, 'eventType' | 'invitationAttachment'> & {
  class?: RegistrationClass | null
  dates?: Array<{ date: DayKey }>
  startDate?: DayKey
}

export const invitationAttachmentFileName = (item: InvitationAttachmentItem): string => {
  const date = item.dates?.[0]?.date ?? item.startDate
  const parts = ['koekutsu', date ? formatDate(date, 'yyyyMMdd') : '', item.eventType, item.class].filter(Boolean)

  return `${parts.join('-')}.pdf`
}

export const startListFileName = (item: Pick<ConfirmedEvent, 'eventType' | 'startDate'>): string => {
  const parts = ['starttilista', formatDate(item.startDate, 'yyyyMMdd'), item.eventType].filter(Boolean)

  return `${parts.join('-')}.xlsx`
}

export const eventBreakdownFileName = (year: number): string => `kokeet-${year}.xlsx`
export const eventClassStatsFileName = (season: number): string => `kokeet-luokittain-${season}.xlsx`
